import {AxiosError} from 'axios';
import {useCustomMutation} from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import {PUT_UPDATE_PROFILE_AMENDMENT_REQUEST_STATUS_URL} from '../../constants/apiUrls';
import {ProfileAmendmentRequestStatus} from './usePutCancelProfileAmendmentRequest';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface UpdateProfileAmendmentRequestStatusRequest {
  status: ProfileAmendmentRequestStatus;
  remarks: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const usePutUpdateProfileAmendmentRequestStatus = ({onSuccess, onError, uuid}: Input) => {
  const putUpdateProfileAmendmentRequestStatus = async (
      reqBody: UpdateProfileAmendmentRequestStatusRequest
  ) => {
    await axiosClient.put<void>(PUT_UPDATE_PROFILE_AMENDMENT_REQUEST_STATUS_URL(uuid), reqBody);
  };

  return useCustomMutation(putUpdateProfileAmendmentRequestStatus, {
    onSuccess,
    onError,
  });
};
